import React, { useState, useRef, useEffect } from 'react';
import { Globe, Search, ChevronDown, Loader2 } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';

const LANGUAGES = [
  { code: 'pt', name: 'Portugues', native: 'Portugues', region: 'Americas' },
  { code: 'en', name: 'English', native: 'English', region: 'Europe' },
  { code: 'es', name: 'Spanish', native: 'Espanol', region: 'Europe' },
  { code: 'fr', name: 'French', native: 'Francais', region: 'Europe' },
  { code: 'de', name: 'German', native: 'Deutsch', region: 'Europe' },
  { code: 'it', name: 'Italian', native: 'Italiano', region: 'Europe' },
  { code: 'nl', name: 'Dutch', native: 'Nederlands', region: 'Europe' },
  { code: 'ru', name: 'Russian', native: 'Russkiy', region: 'Europe' },
  { code: 'uk', name: 'Ukrainian', native: 'Ukrainska', region: 'Europe' },
  { code: 'pl', name: 'Polish', native: 'Polski', region: 'Europe' },
  { code: 'cs', name: 'Czech', native: 'Cestina', region: 'Europe' },
  { code: 'sk', name: 'Slovak', native: 'Slovencina', region: 'Europe' },
  { code: 'hu', name: 'Hungarian', native: 'Magyar', region: 'Europe' },
  { code: 'ro', name: 'Romanian', native: 'Romana', region: 'Europe' },
  { code: 'bg', name: 'Bulgarian', native: 'Balgarski', region: 'Europe' },
  { code: 'hr', name: 'Croatian', native: 'Hrvatski', region: 'Europe' },
  { code: 'sl', name: 'Slovenian', native: 'Slovenscina', region: 'Europe' },
  { code: 'sr', name: 'Serbian', native: 'Srpski', region: 'Europe' },
  { code: 'bs', name: 'Bosnian', native: 'Bosanski', region: 'Europe' },
  { code: 'el', name: 'Greek', native: 'Ellinika', region: 'Europe' },
  { code: 'tr', name: 'Turkish', native: 'Turkce', region: 'Europe' },
  { code: 'sv', name: 'Swedish', native: 'Svenska', region: 'Europe' },
  { code: 'da', name: 'Danish', native: 'Dansk', region: 'Europe' },
  { code: 'no', name: 'Norwegian', native: 'Norsk', region: 'Europe' },
  { code: 'fi', name: 'Finnish', native: 'Suomi', region: 'Europe' },
  { code: 'et', name: 'Estonian', native: 'Eesti', region: 'Europe' },
  { code: 'lv', name: 'Latvian', native: 'Latviesu', region: 'Europe' },
  { code: 'lt', name: 'Lithuanian', native: 'Lietuviu', region: 'Europe' },
  { code: 'is', name: 'Icelandic', native: 'Islenska', region: 'Europe' },
  { code: 'sq', name: 'Albanian', native: 'Shqip', region: 'Europe' },
  { code: 'mk', name: 'Macedonian', native: 'Makedonski', region: 'Europe' },
  { code: 'mt', name: 'Maltese', native: 'Malti', region: 'Europe' },
  { code: 'cy', name: 'Welsh', native: 'Cymraeg', region: 'Europe' },
  { code: 'ga', name: 'Irish', native: 'Gaeilge', region: 'Europe' },
  { code: 'gd', name: 'Scottish Gaelic', native: 'Gaidhlig', region: 'Europe' },
  { code: 'eu', name: 'Basque', native: 'Euskara', region: 'Europe' },
  { code: 'ca', name: 'Catalan', native: 'Catala', region: 'Europe' },
  { code: 'gl', name: 'Galician', native: 'Galego', region: 'Europe' },
  { code: 'lb', name: 'Luxembourgish', native: 'Letzebuergesch', region: 'Europe' },
  { code: 'be', name: 'Belarusian', native: 'Belaruskaya', region: 'Europe' },
  { code: 'hy', name: 'Armenian', native: 'Hayeren', region: 'Europe' },
  { code: 'ka', name: 'Georgian', native: 'Kartuli', region: 'Europe' },
  { code: 'az', name: 'Azerbaijani', native: 'Azerbaycanca', region: 'Europe' },
  { code: 'zh', name: 'Chinese', native: 'Zhongwen', region: 'Asia' },
  { code: 'ja', name: 'Japanese', native: 'Nihongo', region: 'Asia' },
  { code: 'ko', name: 'Korean', native: 'Hangugeo', region: 'Asia' },
  { code: 'hi', name: 'Hindi', native: 'Hindi', region: 'Asia' },
  { code: 'bn', name: 'Bengali', native: 'Bangla', region: 'Asia' },
  { code: 'ta', name: 'Tamil', native: 'Tamil', region: 'Asia' },
  { code: 'te', name: 'Telugu', native: 'Telugu', region: 'Asia' },
  { code: 'mr', name: 'Marathi', native: 'Marathi', region: 'Asia' },
  { code: 'gu', name: 'Gujarati', native: 'Gujarati', region: 'Asia' },
  { code: 'kn', name: 'Kannada', native: 'Kannada', region: 'Asia' },
  { code: 'ml', name: 'Malayalam', native: 'Malayalam', region: 'Asia' },
  { code: 'pa', name: 'Punjabi', native: 'Panjabi', region: 'Asia' },
  { code: 'ur', name: 'Urdu', native: 'Urdu', region: 'Asia' },
  { code: 'ne', name: 'Nepali', native: 'Nepali', region: 'Asia' },
  { code: 'si', name: 'Sinhala', native: 'Sinhala', region: 'Asia' },
  { code: 'th', name: 'Thai', native: 'Phasa Thai', region: 'Asia' },
  { code: 'vi', name: 'Vietnamese', native: 'Tieng Viet', region: 'Asia' },
  { code: 'id', name: 'Indonesian', native: 'Bahasa Indonesia', region: 'Asia' },
  { code: 'ms', name: 'Malay', native: 'Bahasa Melayu', region: 'Asia' },
  { code: 'tl', name: 'Filipino', native: 'Filipino', region: 'Asia' },
  { code: 'my', name: 'Burmese', native: 'Myanmar', region: 'Asia' },
  { code: 'km', name: 'Khmer', native: 'Khmer', region: 'Asia' },
  { code: 'lo', name: 'Lao', native: 'Phasa Lao', region: 'Asia' },
  { code: 'mn', name: 'Mongolian', native: 'Mongol', region: 'Asia' },
  { code: 'ar', name: 'Arabic', native: 'Al-Arabiyyah', region: 'Middle East' },
  { code: 'he', name: 'Hebrew', native: 'Ivrit', region: 'Middle East' },
  { code: 'fa', name: 'Persian', native: 'Farsi', region: 'Middle East' },
  { code: 'ps', name: 'Pashto', native: 'Pashto', region: 'Middle East' },
  { code: 'sw', name: 'Swahili', native: 'Kiswahili', region: 'Africa' },
  { code: 'am', name: 'Amharic', native: 'Amarinja', region: 'Africa' },
  { code: 'ha', name: 'Hausa', native: 'Hausa', region: 'Africa' },
  { code: 'ig', name: 'Igbo', native: 'Igbo', region: 'Africa' },
  { code: 'yo', name: 'Yoruba', native: 'Yoruba', region: 'Africa' },
  { code: 'zu', name: 'Zulu', native: 'isiZulu', region: 'Africa' },
  { code: 'af', name: 'Afrikaans', native: 'Afrikaans', region: 'Africa' },
  { code: 'so', name: 'Somali', native: 'Soomaali', region: 'Africa' },
  { code: 'eo', name: 'Esperanto', native: 'Esperanto', region: 'Other' },
  { code: 'la', name: 'Latin', native: 'Latina', region: 'Other' },
  { code: 'yi', name: 'Yiddish', native: 'Yidish', region: 'Other' },
  { code: 'fy', name: 'Frisian', native: 'Frysk', region: 'Other' },
];

export const LanguageSelector = ({ variant = 'header', className = '' }) => {
  const { language, changeLanguage, isTranslating } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState('');
  const dropdownRef = useRef(null);
  const searchRef = useRef(null);

  const currentLang = LANGUAGES.find(l => l.code === language) || LANGUAGES[0];

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
        setSearch('');
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    if (isOpen && searchRef.current) {
      searchRef.current.focus();
    }
  }, [isOpen]);

  const filtered = LANGUAGES.filter(l =>
    l.name.toLowerCase().includes(search.toLowerCase()) ||
    l.native.toLowerCase().includes(search.toLowerCase()) ||
    l.code.toLowerCase().includes(search.toLowerCase())
  );

  const grouped = filtered.reduce((acc, lang) => {
    if (!acc[lang.region]) acc[lang.region] = [];
    acc[lang.region].push(lang);
    return acc;
  }, {});

  const handleSelect = (code) => {
    changeLanguage(code);
    setIsOpen(false);
    setSearch('');
  };

  const isDark = variant === 'header' || variant === 'dashboard';

  return (
    <div className={`relative ${className}`} ref={dropdownRef} data-testid="language-selector">
      <button
        onClick={() => setIsOpen(!isOpen)}
        data-testid="language-selector-trigger"
        className={`flex items-center gap-2 px-3 py-2 rounded-lg transition-all text-sm font-medium border
          ${isDark
            ? 'bg-white/10 border-white/20 text-white hover:bg-white/20'
            : 'bg-gray-100 border-gray-200 text-gray-700 hover:bg-gray-200'
          }
        `}
      >
        <Globe className="w-4 h-4" />
        <span className="hidden sm:inline">{currentLang.native}</span>
        <span className="sm:hidden">{currentLang.code.toUpperCase()}</span>
        {isTranslating ? (
          <Loader2 className="w-3 h-3 animate-spin" />
        ) : (
          <ChevronDown className={`w-3 h-3 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
        )}
      </button>

      {isOpen && (
        <div
          className={`absolute right-0 top-full mt-2 w-72 rounded-xl shadow-2xl border z-[9999] overflow-hidden
            ${isDark
              ? 'bg-[#1a2a3a] border-white/10'
              : 'bg-white border-gray-200'
            }
          `}
          data-testid="language-selector-dropdown"
        >
          <div className={`p-3 border-b ${isDark ? 'border-white/10' : 'border-gray-100'}`}>
            <div className={`flex items-center gap-2 px-3 py-2 rounded-lg ${isDark ? 'bg-white/5' : 'bg-gray-50'}`}>
              <Search className={`w-4 h-4 ${isDark ? 'text-gray-400' : 'text-gray-400'}`} />
              <input
                ref={searchRef}
                type="text"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Search language..."
                data-testid="language-search-input"
                className={`flex-1 bg-transparent text-sm outline-none ${isDark ? 'text-white placeholder:text-gray-500' : 'text-gray-700 placeholder:text-gray-400'}`}
              />
            </div>
          </div>

          <div className="max-h-80 overflow-y-auto overscroll-contain" data-testid="language-list">
            {Object.entries(grouped).map(([region, langs]) => (
              <div key={region}>
                <div className={`px-4 py-1.5 text-[10px] font-bold uppercase tracking-wider ${isDark ? 'text-gray-500 bg-white/5' : 'text-gray-400 bg-gray-50'}`}>
                  {region}
                </div>
                {langs.map(lang => (
                  <button
                    key={lang.code}
                    onClick={() => handleSelect(lang.code)}
                    data-testid={`language-option-${lang.code}`}
                    className={`w-full flex items-center justify-between px-4 py-2.5 text-sm transition-colors
                      ${language === lang.code
                        ? isDark
                          ? 'bg-[#E6C687]/20 text-[#E6C687]'
                          : 'bg-amber-50 text-amber-700'
                        : isDark
                          ? 'text-gray-300 hover:bg-white/5'
                          : 'text-gray-700 hover:bg-gray-50'
                      }
                    `}
                  >
                    <span className="font-medium">{lang.native}</span>
                    <span className={`text-xs ${isDark ? 'text-gray-500' : 'text-gray-400'}`}>{lang.name}</span>
                  </button>
                ))}
              </div>
            ))}
            {filtered.length === 0 && (
              <div className={`px-4 py-8 text-center text-sm ${isDark ? 'text-gray-500' : 'text-gray-400'}`}>
                No languages found
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export { LANGUAGES };
export default LanguageSelector;
